<!--suppress CssUnusedSymbol, JSUnresolvedVariable, ES6ModulesDependencies -->
<template>
    <div ref="sliderItem" class="pm-smart-treatment-settings--slider-item">
        <div class="pm-smart-treatment-item--tooth-selector" style="position: relative;">
            <div ref="intersectionElement" style="pointer-events: none; position: absolute; top: 0; left: 33%; width: 33%; height: 1px; background: f00;"></div>
            <div v-for="toothId in regionTeethIds" :key="toothId" style="display: inline-block; position: relative;" @touchstart="onTouchStart" @touchmove="onTouchMove" @touchend="toggleSelection(toothId)">
                <v-btn
                    :id="`pm-smart-treatment-item--tooth-selector-${toothId}`"
                    class="roboto bold--text"
                    flat
                    :class="[selectedTeeth.includes(String(toothId)) ? $theme.baseText + ' active' : 'inactive grey--text', fullJaw ? 'full-jaw' : 'not-full-jaw']"
                >
                    {{ Helper.getToothNotation(toothId) }}
                </v-btn>

                <div v-if="fullJaw && isToothEditable(toothId)" class="pm-smart-treatment-item--settings--tooth-marker-top" style="opacity: 1; margin-top: -16px; transition: all .5s;">
                    <v-icon class="editable-tooth">
                        small_lock_open
                    </v-icon>
                </div>


                <div v-if="markers[String(toothId)] && markers[String(toothId)].crown.length > 1" class="pm-smart-treatment-item--settings--tooth-marker-top red white--text bold--text" style="opacity: 1">
                    !
                </div>
                <div v-else-if="markers[String(toothId)] && markers[String(toothId)].crown.length > 0"
                     class="pm-smart-treatment-item--settings--tooth-marker-top"
                     :style="markers[String(toothId)] && markers[String(toothId)].crown[0] === activeTreatmentPid ? `background: ${fullJaw ? '#2862e6' : '#d27694'}; color: #fff;` : 'background: #fff; color: #888; border: 1px solid #bbb;'"
                     v-text="$t('plan_calculator.marker_' + markers[String(toothId)].crown[0])"
                />

                <div v-if="markers[String(toothId)] && markers[String(toothId)].root.length > 1" class=" pm-smart-treatment-item--settings--tooth-marker-bottom red white--text bold--text">
                    !
                </div>
                <div v-else-if="markers[String(toothId)] && markers[String(toothId)].root.length > 0"
                     class="pm-smart-treatment-item--settings--tooth-marker-bottom"
                     :style="markers[String(toothId)] && markers[String(toothId)].root[0] === activeTreatmentPid ? `background: ${fullJaw ? '#2862e6' : '#d27694'}; color: #fff;` : 'background: #fff; color: #888; border: 1px solid #bbb;'"
                     v-text="$t('plan_calculator.marker_' + markers[String(toothId)].root[0])"
                />

                <div v-if="$store.state.simplePlan.blinking || $store.state.simplePlan.blinkingToothId === toothId" class="animation-blinking pm-smart-treatment-item--settings--tooth-marker-top red white--text bold--text" style="opacity: 0">
                    !
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.editable-tooth {
    font-size: 11px !important;
}

.pm-smart-treatment-item--tooth-selector {
        margin-bottom: 8px;
        width: 100vw;

        @media (min-width: 700px) {
            .v-btn {
                padding: 24px 32px !important;
                border-radius: 30px !important;
                font-size: 18px;
            }
        }

        & .v-btn {
            border-radius: 20px;
            height: 40px!important;
            padding: 0;
            margin-left: 6px;
            margin-right: 6px;
            min-width: auto;
            width: 48px;
            max-width: 12vw!important;

            &.active {
                border: 2px solid rgba(40, 98, 230, 1)!important;

                &.full-jaw {
                    border: 2px solid rgba(40, 98, 230, 1) !important;
                }

                &.not-full-jaw {
                    border: 2px solid #d493a8 !important;
                }
            }
            &.inactive {
                border: 2px solid #dfe1e3!important;
            }
        }
    }


@media (min-width: 700px) {
    .pm-smart-treatment-item--settings--tooth-marker-top,
    .pm-smart-treatment-item--settings--tooth-marker-bottom {
        height: 20px !important;
        width: 20px !important;
        line-height: 20px !important;
        font-size: 12px !important;
        margin-left: -10px !important;
    }

    .pm-smart-treatment-item--settings--tooth-marker-top {
        margin-top: -4px;
    }

    .pm-smart-treatment-item--settings--tooth-marker-bottom {
        margin-bottom: -4px;
    }
}
</style>

<script>

import PlanSimpleModifierService from "../../extensions/services/plan-simple-modifier-service";
import PlanSimpleStatusGenerator from "../../extensions/services/plan-simple-status-generator";
import PlanSimpleService from "../../extensions/services/plan-simple-service";

export default {
    props: ["regionId", "markers", "selectedTeeth", "editableTeeth", "fullJaw", "activeTreatmentPid"],
    data() {
        return ({
            regionTeethIds: [],
            preventOverride: false,
            overrideTimeout: null,
            options: {
                root: document.querySelector(".pm-smart-treatment-settings--slider"),
                rootMargin: "0px",
                threshold: 0.5,
            },
        });
    },
    created() {
        this.isMoving = false;
        this.regionTeethIds = Helper.getRegionTeethIds(this.regionId);

        this.registerBusEvent('region-selector:select', (regionId) => {
            this.preventOverride = true;
            if (this.overrideTimeout) clearTimeout(this.overrideTimeout);
            this.overrideTimeout = window.setTimeout(()=>{
                this.preventOverride = false;
            },500);
        });
    },
    mounted() {
        this.initIntersectionObserver();
        //this.initSwipeObserver();
    },
    beforeDestroy() {
        // @todo: remove IntersectionObserver
        // IntersectionObserver.unobserve(this.$refs.sliderItem);
    },
    methods: {
        initIntersectionObserver() {
            let options = {
                root: document.querySelector('.pm-smart-treatment-item--settings'),
                rootMargin: '0px',
                threshold: 1.0
            }

            let observer = new IntersectionObserver((entries)=>{
                if (entries[0].isIntersecting && !this.preventOverride) this.$emit("selectRegion", this.regionId);
            }, options);

            let target = this.$refs['intersectionElement'];
            observer.observe(target);
        },
        /*initSwipeObserver() {
            const observer = new IntersectionObserver((entries, observer) => this.swipeCallback(entries, observer), this.options);
            observer.observe(this.$refs.sliderItem);
            // sections.forEach((section) => observer.observe(section));
        },

        swipeCallback(entries, observer) {
            if (entries[0].isIntersecting) {
                this.$emit("selectRegion", this.regionId);
            }
        },*/

        isToothEditable(toothId) {
            if (!this.fullJaw) return true;
            if (this.fullJaw && !this.editableTeeth) return false;
            if (this.editableTeeth === null) return true;
            const id = parseInt(toothId) % 10;
            return this.editableTeeth.includes(id);
        },

        onTouchStart() {
            this.isMoving = false;
        },

        onTouchMove() {
            this.isMoving = true;
        },

        toggleSelection(toothId) {
            event.stopPropagation();
            event.preventDefault();
            if (this.isMoving) {
                this.isMoving = false;
                return;
            }
            if (!this.isToothEditable(toothId)) {
                this.$bus.$emit("app.showSnackbar", {text: this.editableTeeth === null ? this.$t("plan_simple.not_editable_" + this.activeTreatmentPid) : this.$t("plan_simple.editable_" + this.activeTreatmentPid + "_"+ this.editableTeeth.join("_"))});
                return;
            }
            this.$emit("toggleSelection", toothId);
            this.$set(this.$store.state.simplePlan, "emailSent", false);
        },


    },
};
</script>
